export default __webpack_public_path__ + "static/Plots0035-4cb0b5614864f9551953141719412728.jpg";